import shutterSettingsGen3 from './shutter_settings_gen_3';

export default {
	title: 'settings',
	components: [
		shutterSettingsGen3.components[0],
		{ title: 'display_mode', component: 'display_mode_g2' },
		...shutterSettingsGen3.components.slice(1),
	],
};
